import {Action} from '@ngrx/store';
import {DressCodePicture} from '../../../models/dress-code-picture';
import {BijbEvent} from '../../../models/bijb-event';

export class AddDressCodePictureAction implements Action {
  public static readonly type = 'AddDressCodePictureAction';

  constructor(public bijbEvent: BijbEvent, public dressCodePicture: DressCodePicture) {
  }

  public type = AddDressCodePictureAction.type;
}
